import { render, staticRenderFns } from "./ServiceBanner.vue?vue&type=template&id=32d50ed9&scoped=true"
import script from "./ServiceBanner.vue?vue&type=script&lang=js"
export * from "./ServiceBanner.vue?vue&type=script&lang=js"
import style0 from "./ServiceBanner.vue?vue&type=style&index=0&id=32d50ed9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d50ed9",
  null
  
)

export default component.exports